import get from 'lodash.get';
import pick from 'lodash.pick';
import messages from './Address.messages';
import { DOWNLOAD_ONLY } from '../../constants/cartTypes';

const createFieldValidator = (field) => {
  const { isRequired, title, maxLength } = field;

  return (value) => {
    if (isRequired && !value) {
      return {
        ...messages.validationError,
        args: { field: title.props },
      };
    }

    if (maxLength && value && value.length > maxLength) {
      return {
        ...messages.maxLengthValidationError,
        args: { field: title.props, maxLength },
      };
    }

    return undefined;
  };
};

const addFieldValidators = (fields) =>
  fields.map((field) => ({ ...field, validate: createFieldValidator(field) }));

const getFormattedShouldMatchError = (fields, id) => ({
  ...messages.shouldMatchError,
  args: {
    field: get(fields.filter((field) => field.id === id)[0], 'title.props'),
  },
});

const lowercase = (string) =>
  typeof string === 'string' ? string.toLowerCase() : string;

const validateWholeForm = (fields) => (values, props) => {
  const { isAddAddressShown } = props;
  const isSameShipping = values.same_shipping;

  if (
    props.data.loading ||
    props.data.user.cart.type === DOWNLOAD_ONLY ||
    isSameShipping
  ) {
    return null;
  }

  const { addresses } = props.data.user;

  const shippingData = isAddAddressShown
    ? {
        firstName: values.shipping_address_first_name,
        lastName: values.shipping_address_last_name,
        countryCode: values.shipping_address_country_code,
      }
    : addresses.filter((a) => a.id === values.shipping_address)[0] || {};

  const billingData = !isSameShipping
    ? {
        firstName: values.billing_address_first_name,
        lastName: values.billing_address_last_name,
        countryCode: values.billing_address_country_code,
      }
    : addresses.filter((a) => a.id === values.billing_address)[0] || {};

  const isDifferentFirstName =
    lowercase(shippingData.firstName) !== lowercase(billingData.firstName);
  const isDifferentLastName =
    lowercase(shippingData.lastName) !== lowercase(billingData.lastName);
  const isDifferentCountry =
    shippingData.countryCode !== billingData.countryCode;

  const errors = {
    shipping_address_first_name:
      shippingData.firstName &&
      billingData.firstName &&
      isAddAddressShown &&
      isDifferentFirstName &&
      getFormattedShouldMatchError(fields, 'shipping_address_first_name'),
    shipping_address_last_name:
      shippingData.lastName &&
      billingData.firstName &&
      isAddAddressShown &&
      isDifferentLastName &&
      getFormattedShouldMatchError(fields, 'shipping_address_last_name'),
    shipping_address_country_code:
      shippingData.countryCode &&
      billingData.countryCode &&
      isAddAddressShown &&
      isDifferentCountry &&
      getFormattedShouldMatchError(fields, 'shipping_address_country_code'),
    billing_address_first_name:
      billingData.firstName &&
      shippingData.firstName &&
      !isSameShipping &&
      isDifferentFirstName &&
      getFormattedShouldMatchError(fields, 'billing_address_first_name'),
    billing_address_last_name:
      billingData.lastName &&
      shippingData.firstName &&
      !isSameShipping &&
      isDifferentLastName &&
      getFormattedShouldMatchError(fields, 'billing_address_last_name'),
    billing_address_country_code:
      billingData.countryCode &&
      shippingData.countryCode &&
      !isSameShipping &&
      isDifferentCountry &&
      getFormattedShouldMatchError(fields, 'billing_address_country_code'),
  };

  const actualErrorKeys = Object.keys(errors).filter((key) => !!errors[key]);

  const errorMap =
    actualErrorKeys.length > 0 ? pick(errors, actualErrorKeys) : null;

  return errorMap;
};

export { createFieldValidator, addFieldValidators, validateWholeForm };
